
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  resolveAddButtonState,
  AddButtonState,
} from './PurchaseListSelectionToolbar';
import { FloatingBarInsetReservation } from '@/services/floatingActionsBarInset';

export { resolveAddButtonState } from './PurchaseListSelectionToolbar';

@Component({})
export default class PurchaseListSelectionToolbar extends Vue {
  @Prop({ default: 0 }) public count!: number;
  @Prop({ type: Boolean, default: false }) public readonly hasPurchaseListAccess!: boolean;
  @Prop({ default: 50 }) public maxBatch!: number;
  @Prop({ default: false }) public busy!: boolean;

  private insetReservation = new FloatingBarInsetReservation();

  public get ariaLabel(): string { return 'Bulk actions for selected rows'; }

  public get addState(): AddButtonState {
    return resolveAddButtonState({
      count: this.count,
      hasPurchaseListAccess: this.hasPurchaseListAccess,
      maxBatch: this.maxBatch,
      busy: this.busy,
    });
  }

  public onAdd(): void {
    if (this.addState.disabled) { return; }
    this.$emit('add');
  }

  @Watch('count', { immediate: true })
  private onCountChange(newCount: number): void {
    this.insetReservation.syncFromCount(newCount);
  }

  private beforeDestroy(): void {
    this.insetReservation.release();
  }
}
